const o=o=>encodeURIComponent(o).replaceAll(/[!'()*]/g,(o=>"%"+o.codePointAt(0)?.toString(16)));export{o as encodeNonURIComponent};
